import React, {useEffect, useState} from 'react'
import {Button, Col, Form, Input, message} from 'antd'
import Title from 'antd/es/typography/Title'
import {useSelector} from 'react-redux'
import {getUser, updatePwd} from '../../api/user'
import Text from 'antd/es/typography/Text'
import {EditOutlined} from "@ant-design/icons";
import HttpError from "../base/HttpError";
import {is_admin_user} from "../../app/role";

function ChangePasswordForm(props) {
    const [form] = Form.useForm()
    // const [password, setPassword] = useState([])
    const [email, setEmail] = useState([])

    const role = useSelector((state) => state.user.info.role)
    let userEmail = useSelector((state) => state.user.info.email)
    const userId = useSelector((state) => state.user.info.userId)

    useEffect(() => {
        let mounted = true
        if (is_admin_user({role: role}) && userId) {
            getUser(userId)
                .then((response) => {
                    const user = response.data
                    if (mounted) setEmail(user.email)
                })
                .catch((error) => {
                    message.error(error.message).then(() => {
                    })
                })
        } else {
            if (mounted) setEmail(userEmail)
        }
        return () => (mounted = false)
    }, [])

    const tailFormItemLayout = {
        wrapperCol: {
            xs: {
                span: 24,
                offset: 0
            },
            sm: {
                span: 16,
                offset: 8
            }
        }
    }

    const onFinish = (values) => {
        const old_password = values.old_password
        const new_password = values.new_password
        updatePwd(userId, old_password, new_password)
            .then((response) => {
                message.success('Password updated successfully').then(() => {
                })
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    message.error(error.response.data.msg).then((r) => {
                    })
                } else {
                    HttpError(error)
                }
            })
    }

    return (
        <div>
            <Form
                labelCol={{span: 4}}
                wrapperCol={{span: 16, offset: 1}}
                colon={false}
                form={form}
                name='Change Password'
                onFinish={onFinish}
                initialValues={{
                    prefix: '86'
                }}
                scrollToFirstError
            >
                <Title>Change your password</Title>
                {is_admin_user({role: role}) && (
                    <>
                        <Form.Item>
                            <Text> &quot;Admin Hint: Your are updating password for user with below email&quot;</Text>
                        </Form.Item>
                    </>
                )}
                <Form.Item
                    name='email'
                    label='E-mail'
                    rules={[
                        {
                            type: 'email',
                            message: 'The input is not valid E-mail!'
                        },
                        {
                            required: false,
                            message: 'Please input your E-mail!'
                        }
                    ]}
                >
                    <Text>{email}</Text>
                </Form.Item>
                <Form.Item
                    name='old_password'
                    label='Password'
                    rules={[
                        {
                            required: true,
                            message: 'Please input your password!'
                        }
                    ]}
                    hasFeedback
                >
                    <Input.Password/>
                </Form.Item>

                <Form.Item
                    name='new_password'
                    label='New Password'
                    rules={[
                        {
                            required: true,
                            message: 'Please input your new password!'
                        },
                        {min: 8, message: 'Password must be minimum 8 characters.'}
                    ]}
                    hasFeedback
                >
                    <Input.Password/>
                </Form.Item>

                <Form.Item
                    name='confirm_new'
                    label='Confirm New Password'
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: 'Please confirm your password!'
                        },
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('new_password') === value) {
                                    return Promise.resolve()
                                }
                                return Promise.reject(new Error('The two passwords that you entered do not match!'))
                            }
                        })
                    ]}
                >
                    <Input.Password/>
                </Form.Item>
                <Col span={24} style={{padding: 12}}>
                    <div style={{float: 'right', marginRight: '11%'}}>
                        <Button type='primary' htmlType='submit' size={'large'}>
                            <EditOutlined/>
                            Confirm Change Password
                        </Button>
                    </div>
                </Col>
            </Form>
        </div>
    )
}

export default ChangePasswordForm
